const header = document.querySelector('.header');

let lastScrollTop = 0;

export function checkScrollTop(scrollTop) {
  if (scrollTop < 0) scrollTop = 0;

  if (scrollTop <= 10) {
    header.classList.remove('is-scroll');
  } else {
    header.classList.add('is-scroll');
  }

  const delta = scrollTop - lastScrollTop;

  if (Math.abs(delta) < 1) {
    lastScrollTop = scrollTop;
    return;
  }

  if (delta > 0) {
    header.classList.add('is-top');
  } else {
    header.classList.remove('is-top');
  }

  lastScrollTop = scrollTop;
}

checkScrollTop(window.scrollY);
